import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  BillingDetailsRow,
  BillingDetailsTextWrapper,
  BillingSectionEdit,
  BillingSectionTitle,
  BillingSectionTitleRow,
} from 'Features/accountSettings/components/Billing/Billing.styled'
import { convertLabelAndId } from 'Utils/convertLabelAndIdHelper'
import UsStates from 'Assets/lists/usStates'
import { Countries } from 'Assets/lists/countries'
import { AccountSettings } from 'Types/AccountSettings'
type BillingDetailsProps = {
  accounts: AccountSettings | undefined
  openEditBillingModal: () => void
}

export const BillingDetails = ({ accounts, openEditBillingModal }: BillingDetailsProps) => {
  const { t } = useTranslation('accountSettings')

  return (
    <>
      <BillingSectionTitleRow>
        <BillingSectionTitle>{t('billing_page.billing_details')}</BillingSectionTitle>
        <BillingSectionEdit onClick={() => openEditBillingModal()}>
          {t('billing_page.edit')}
        </BillingSectionEdit>
      </BillingSectionTitleRow>
      {accounts && (
        <BillingDetailsTextWrapper>
          <BillingDetailsRow>
            {accounts.companyName} {accounts.companyVatId ? `(${accounts.companyVatId})` : ''}
          </BillingDetailsRow>
          <BillingDetailsRow>{accounts.street}</BillingDetailsRow>
          <BillingDetailsRow>
            {accounts.city ? `${accounts.city}, ` : ''}
            {accounts.state
              ? `${convertLabelAndId('value', accounts.state || '', UsStates) || accounts.state}, `
              : ''}
            {accounts.zipCode ? `${accounts.zipCode}` : ''}
          </BillingDetailsRow>
          <BillingDetailsRow>
            {convertLabelAndId('value', accounts.country, Countries) || accounts.country}
          </BillingDetailsRow>
        </BillingDetailsTextWrapper>
      )}
    </>
  )
}
